// eslint-disable-next-line import/prefer-default-export
export const NO_SELECT_NUMBER = 0;
